import React from 'react';
export function Valuation() {
  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="valuation" className="relative py-24 md:py-32 bg-brand-stone-900 overflow-hidden bg-texture" data-id="element-194">
      {/* Parallax mountain background */}
      <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/mb2xEDjs23jSnBPDJdsGrY/katie-moum-WwukJJLkAdE-unsplash.jpg")',
      backgroundAttachment: 'fixed'
    }} data-id="element-195"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-brand-stone-900/70 via-brand-stone-900/85 to-brand-stone-900" data-id="element-196"></div>

      {/* Subtle background watermark */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-5 pointer-events-none" data-id="element-197">
        <svg width="600" height="600" viewBox="0 0 100 100" fill="currentColor" className="text-brand-copper" data-id="element-198">
          <path d="M40,20 C25,20 15,30 15,45 C15,60 25,70 40,70 L45,70 L45,60 L40,60 C30,60 25,55 25,45 C25,35 30,30 40,30 L60,30 C70,30 75,35 75,45 L75,50 L85,50 L85,45 C85,30 75,20 60,20 L40,20 Z" data-id="element-199" />
          <path d="M60,80 C75,80 85,70 85,55 L85,50 L75,50 L75,55 C75,65 70,70 60,70 L40,70 L40,80 L60,80 Z" data-id="element-200" />
          <rect x="50" y="45" width="40" height="10" data-id="element-201" />
          <rect x="70" y="55" width="10" height="15" data-id="element-202" />
          <rect x="85" y="55" width="10" height="15" data-id="element-203" />
        </svg>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 text-center" data-id="element-204">
        <h2 className="text-3xl md:text-5xl font-serif text-white mb-6" data-id="element-205">
          What's Your Home Worth?
        </h2>
        <p className="text-brand-silver text-lg md:text-xl max-w-2xl mx-auto mb-10 font-light" data-id="element-206">
          Get a free, accurate, data-backed valuation of your property from our
          local experts.
        </p>

        <button onClick={scrollToContact} className="bg-brand-copper hover:bg-brand-copper/90 text-white px-10 py-4 rounded-lg font-medium transition-colors text-lg" data-id="element-207">
          Get My Home Value
        </button>
      </div>
    </section>;
}